/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebsiteunreadableerror3Inputs */

const en_placewebsiteunreadableerror3 = /** @type {(inputs: Placewebsiteunreadableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The website could not be read. Check the address or create the place without a website.`)
};

const de_placewebsiteunreadableerror3 = /** @type {(inputs: Placewebsiteunreadableerror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Website ließ sich nicht lesen. Prüf die Adresse oder leg den Ort ohne Website an.`)
};

/**
* | output |
* | --- |
* | "The website could not be read. Check the address or create the place without a website." |
*
* @param {Placewebsiteunreadableerror3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebsiteunreadableerror3 = /** @type {((inputs?: Placewebsiteunreadableerror3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebsiteunreadableerror3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebsiteunreadableerror3(inputs)
	return de_placewebsiteunreadableerror3(inputs)
});
export { placewebsiteunreadableerror3 as "placeWebsiteUnreadableError" }